import { render, staticRenderFns } from "./ProductsSetPreview.vue?vue&type=template&id=af0edebe"
import script from "./ProductsSetPreview.vue?vue&type=script&lang=js"
export * from "./ProductsSetPreview.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports